import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesUp, faAnglesDown, faPlusSquare, faMinusSquare } from "@fortawesome/free-solid-svg-icons";
import SearchField from "../SearchField/SearchField";
import SPQSFormGroup from "./SPQSFormGroup";
import {
  handlePaytermInputChange,
  handlePaytermInputBlur,
  SelectPayType,
  handleDelPayRow,
  handleAddPayRow,
} from "./utils/inputhandlers";
import useSPQS from "../../hooks/useSPQS";
import useSPQSUndo from "../../hooks/useSPQSUndo";

const QSSPPayment = ({
  ignoreEnter,
  clearfield,
  loadedPpayterm,
  loadedPpaytermData,
  loadedSpayterm,
  loadedSpaytermData,
}) => {
  // Load Context Values
  const {
    ppaymenttermSPQS,
    setPpaymenttermSPQS,
    ppaymenttermDataSPQS,
    setPpaymenttermDataSPQS,
    ppayrowSPQS,
    spaymenttermSPQS,
    setSpaymenttermSPQS,
    spaymenttermDataSPQS,
    setSpaymenttermDataSPQS,
    spayrowSPQS,
    qstoeditSP,
    SPQS,
  } = useSPQS();
  const {
    setEditingFieldSPQS,
    SPQSEdits,
    editIDSPQS,
    setEditIDSPQS,
    editingFieldSPQS,
    undoListSPQS,
    setReloadpaytermsSPQS,
    inputRefsSPQS,
  } = useSPQSUndo();

  return (
    <>
      <fieldset>
        <legend>
          Purchase Payment Terms:
          {SPQS.qstype !== 2 && (
            <FontAwesomeIcon
              icon={faPlusSquare}
              onClick={(e) =>
                handleAddPayRow(
                  setPpaymenttermSPQS,
                  setPpaymenttermDataSPQS,
                  ppayrowSPQS,
                  SPQSEdits,
                  editIDSPQS,
                  setEditIDSPQS,
                  undoListSPQS,
                  loadedPpayterm,
                  loadedPpaytermData,
                  qstoeditSP,
                  "purchase"
                )
              }
            />
          )}
        </legend>
        <SPQSFormGroup
          readOnly={SPQS.qstype === 2}
          labelname={"Interest Rate"}
          inputname={"pinterest"}
          inputtype={"percent"}
          style={{ minWidth: "45px", maxWidth: "55px", marginBottom: "1rem", textAlign: "right" }}
        />
        <div className='SPpayterms'>
          <div className='SPpayterm-headers'>
            <p></p>
            <p>Portion</p>
            <p>Type</p>
            <p>Days</p>
          </div>
          {ppaymenttermSPQS &&
            ppaymenttermSPQS.map((el, ind) => {
              let paykeys = Object.keys(el);
              return (
                <div key={"pposrowpay-" + ind} className='SPpayterm-content'>
                  <p>{ind + 1 + ":"}</p>
                  {paykeys &&
                    paykeys.map((el1) => {
                      if (
                        el1 !== "SPQSID" &&
                        el1 !== "QSPaytermID" &&
                        el1 !== "row" &&
                        el1 !== "type" &&
                        el1 !== "origin"
                      ) {
                        if (el1 !== "payType" || SPQS.qstype === 2) {
                          return (
                            <input
                              readOnly={SPQS.qstype === 2}
                              className={SPQS.qstype === 2 ? "spqsreadonlyinput" : ""}
                              tabIndex={SPQS.qstype === 2 && -1}
                              required
                              id={el1 + ind}
                              autoComplete='off'
                              key={ind + "-" + el1}
                              name={el1}
                              value={el[el1]}
                              onFocus={(e) => SPQS.qstype !== 2 && e.target.select()}
                              onChange={(e) => {
                                SPQS.qstype !== 2 &&
                                  handlePaytermInputChange(
                                    ind,
                                    el1,
                                    e,
                                    ppaymenttermSPQS,
                                    ppaymenttermDataSPQS,
                                    setPpaymenttermSPQS,
                                    setPpaymenttermDataSPQS,
                                    setEditingFieldSPQS
                                  );
                              }}
                              onBlur={(e) => {
                                SPQS.qstype !== 2 &&
                                  handlePaytermInputBlur(
                                    ind,
                                    el1,
                                    e,
                                    ppaymenttermSPQS,
                                    setPpaymenttermSPQS,
                                    SPQSEdits,
                                    editingFieldSPQS,
                                    editIDSPQS,
                                    setEditIDSPQS,
                                    setEditingFieldSPQS,
                                    undoListSPQS,
                                    ppaymenttermDataSPQS,
                                    "purchase"
                                  );
                              }}
                              onKeyDown={ignoreEnter}
                              ref={(elem) => {
                                return (inputRefsSPQS.current["purchase" + el1 + (el?.posPaytermID || el?.row)] = elem);
                              }}
                            />
                          );
                        } else {
                          return (
                            <SearchField
                              key={ind + "-" + el1}
                              required={true}
                              searchURL='/api/positions/getpaytypes'
                              value={el[el1] || ""}
                              valueName='payType'
                              refName={"purchasepayType" + (el.posPaytermID || el.row)}
                              valueID='payTypeID'
                              style={{ width: "40px" }}
                              customplaceholder='payType'
                              onItemSelect={(item) => {
                                SelectPayType(
                                  item,
                                  ind,
                                  ppaymenttermSPQS,
                                  setPpaymenttermSPQS,
                                  ppaymenttermDataSPQS,
                                  setPpaymenttermDataSPQS,
                                  editingFieldSPQS,
                                  SPQSEdits,
                                  editIDSPQS,
                                  el1,
                                  setEditIDSPQS,
                                  setEditingFieldSPQS,
                                  undoListSPQS,
                                  "purchase"
                                );
                              }}
                              clearfield={clearfield}
                            />
                          );
                        }
                      }
                    })}{" "}
                  {SPQS.qstype !== 2 && (
                    <p>
                      <FontAwesomeIcon
                        style={{ marginLeft: "0.4rem" }}
                        icon={faMinusSquare}
                        onClick={(e) =>
                          handleDelPayRow(
                            ppaymenttermSPQS,
                            ppaymenttermDataSPQS,
                            setPpaymenttermSPQS,
                            setPpaymenttermDataSPQS,
                            setReloadpaytermsSPQS,
                            ind,
                            SPQSEdits,
                            editIDSPQS,
                            setEditIDSPQS,
                            undoListSPQS,
                            ppayrowSPQS,
                            loadedPpayterm,
                            loadedPpaytermData,
                            "purchase"
                          )
                        }
                      />
                    </p>
                  )}
                </div>
              );
            })}
        </div>
      </fieldset>
      <fieldset>
        <legend>
          Sales Payment Terms:
          <FontAwesomeIcon
            icon={faPlusSquare}
            onClick={(e) =>
              handleAddPayRow(
                setSpaymenttermSPQS,
                setSpaymenttermDataSPQS,
                spayrowSPQS,
                SPQSEdits,
                editIDSPQS,
                setEditIDSPQS,
                undoListSPQS,
                loadedSpayterm,
                loadedSpaytermData,
                qstoeditSP,
                "sales"
              )
            }
          />
        </legend>
        <SPQSFormGroup
          labelname={"Interest Rate"}
          inputname={"sinterest"}
          inputtype={"percent"}
          style={{ minWidth: "45px", maxWidth: "55px", marginBottom: "1rem", textAlign: "right" }}
        />
        <div className='SPpayterms'>
          <div className='SPpayterm-headers'>
            <p></p>
            <p>Portion</p>
            <p>Type</p>
            <p>Days</p>
          </div>
          {spaymenttermSPQS &&
            spaymenttermSPQS.map((el, ind) => {
              let paykeys = Object.keys(el);
              return (
                <div key={"pposrowpay-" + ind} className='SPpayterm-content'>
                  <p>{ind + 1 + ":"}</p>
                  {paykeys &&
                    paykeys.map((el1) => {
                      if (
                        el1 !== "SPQSID" &&
                        el1 !== "QSPaytermID" &&
                        el1 !== "row" &&
                        el1 !== "type" &&
                        el1 !== "origin"
                      ) {
                        if (el1 !== "payType") {
                          return (
                            <input
                              required
                              id={el1 + ind}
                              autoComplete='off'
                              key={ind + "-" + el1}
                              name={el1}
                              value={el[el1]}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) => {
                                handlePaytermInputChange(
                                  ind,
                                  el1,
                                  e,
                                  spaymenttermSPQS,
                                  spaymenttermDataSPQS,
                                  setSpaymenttermSPQS,
                                  setSpaymenttermDataSPQS,
                                  setEditingFieldSPQS
                                );
                              }}
                              onBlur={(e) => {
                                handlePaytermInputBlur(
                                  ind,
                                  el1,
                                  e,
                                  spaymenttermSPQS,
                                  setSpaymenttermSPQS,
                                  SPQSEdits,
                                  editingFieldSPQS,
                                  editIDSPQS,
                                  setEditIDSPQS,
                                  setEditingFieldSPQS,
                                  undoListSPQS,
                                  spaymenttermDataSPQS,
                                  "sales"
                                );
                              }}
                              onKeyDown={ignoreEnter}
                              ref={(elem) => {
                                return (inputRefsSPQS.current["sales" + el1 + (el?.posPaytermID || el?.row)] = elem);
                              }}
                            />
                          );
                        } else {
                          return (
                            <SearchField
                              key={ind + "-" + el1}
                              required={true}
                              searchURL='/api/positions/getpaytypes'
                              value={el[el1] || ""}
                              valueName='payType'
                              refName={"salespayType" + (el.posPaytermID || el.row)}
                              valueID='payTypeID'
                              style={{ width: "40px" }}
                              customplaceholder='payType'
                              onItemSelect={(item) => {
                                SelectPayType(
                                  item,
                                  ind,
                                  spaymenttermSPQS,
                                  setSpaymenttermSPQS,
                                  spaymenttermDataSPQS,
                                  setSpaymenttermDataSPQS,
                                  editingFieldSPQS,
                                  SPQSEdits,
                                  editIDSPQS,
                                  el1,
                                  setEditIDSPQS,
                                  setEditingFieldSPQS,
                                  undoListSPQS,
                                  "sales"
                                );
                              }}
                              clearfield={clearfield}
                            />
                          );
                        }
                      }
                    })}{" "}
                  <p>
                    <FontAwesomeIcon
                      style={{ marginLeft: "0.4rem" }}
                      icon={faMinusSquare}
                      onClick={(e) =>
                        handleDelPayRow(
                          spaymenttermSPQS,
                          spaymenttermDataSPQS,
                          setSpaymenttermSPQS,
                          setSpaymenttermDataSPQS,
                          setReloadpaytermsSPQS,
                          ind,
                          SPQSEdits,
                          editIDSPQS,
                          setEditIDSPQS,
                          undoListSPQS,
                          spayrowSPQS,
                          loadedSpayterm,
                          loadedSpaytermData,
                          "sales"
                        )
                      }
                    />
                  </p>
                </div>
              );
            })}
        </div>
      </fieldset>
    </>
  );
};

export default QSSPPayment;
